import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import CookieConsent from '../../components/CookieConsent';
import BlogList, { getBlogPostBySlug } from '../../components/Blog';
import { Container, Section } from '../../components/common';
import { ArrowLeft, CheckCircle } from 'lucide-react';

const BlogArticle = ({ post }) => {
  return (
    <>
      <Header />
      <main>
        <Section className="blog-article-hero bg-light-custom">
          <Container>
            <a href="/blog" className="blog-back-link">
              <ArrowLeft size={18} />
              Voltar para o blog
            </a>
            <div className="blog-article-heading">
              <span className="section-eyebrow">{post.category}</span>
              <h1 className="fw-bold mb-4">{post.title}</h1>
              <p className="lead text-secondary mb-0">{post.intro}</p>
            </div>
          </Container>
        </Section>

        <Section className="bg-white">
          <Container>
            <article className="blog-article">
              <div className="blog-article__summary">
                <h2 className="h4 fw-bold mb-3">Principais pontos</h2>
                <ul>
                  {post.highlights.map((highlight) => (
                    <li key={highlight}>
                      <CheckCircle size={18} />
                      <span>{highlight}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {post.sections.map((section) => (
                <section key={section.title} className="blog-article__section">
                  <h2 className="h4 fw-bold mb-3">{section.title}</h2>
                  <p>{section.body}</p>
                </section>
              ))}

              <div className="blog-article__cta">
                <h2 className="h4 fw-bold mb-2">Quer aplicar isso no seu restaurante?</h2>
                <p className="text-secondary mb-0">
                  Fale com o Léo Delivery para entender como organizar vendas, atendimento e operação em um único fluxo.
                </p>
                <a href="/#contato" className="btn btn-primary-custom">Receber diagnóstico</a>
              </div>
            </article>
          </Container>
        </Section>
      </main>
      <Footer />
      <CookieConsent />
    </>
  );
};

const BlogPage = () => {
  const path = window.location.pathname.replace(/\/$/, '');
  const slug = path.startsWith('/blog/') ? path.replace('/blog/', '') : null;
  const post = slug ? getBlogPostBySlug(slug) : null;

  if (slug && post) {
    return <BlogArticle post={post} />;
  }

  if (slug && !post) {
    return (
      <>
        <Header />
        <main>
          <Section className="bg-light-custom">
            <Container className="text-center">
              <span className="section-eyebrow">Blog</span>
              <h1 className="fw-bold mb-3">Conteúdo não encontrado</h1>
              <p className="text-secondary lead mb-4">O artigo acessado não existe ou foi removido.</p>
              <a href="/blog" className="btn btn-primary-custom">Ver conteúdos do blog</a>
            </Container>
          </Section>
        </main>
        <Footer />
        <CookieConsent />
      </>
    );
  }

  return (
    <>
      <Header />
      <main>
        <BlogList compact />
      </main>
      <Footer />
      <CookieConsent />
    </>
  );
};

export default BlogPage;
